













import Vue from "vue";
import iwInputText from "@/encoding/components/buildingBlocks/InputText.vue";
import { mapGetters } from "vuex";

export default Vue.extend({
    components: {
        iwInputText: iwInputText
    },
    data: function() {
        return {
            pathInStore: "property.location.address.street",
        };
    },
    computed: {
        ...mapGetters({
            isReadonlyField: "FormModule/isReadonlyField",
            editNotAllowed: "FormModule/editNotAllowed"
        }),
        street: function(): string | null {
            return this.$store.getters["FormModule/getValue"](this.pathInStore);
        },
    },
    methods: {
        updateText: function (event: Event) {
            const target = event.target as HTMLInputElement;
            const value = target.value;

            if (value == "") {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            } else {
                this.$store.dispatch("FormModule/addValue", {path: this.pathInStore, value: value});
            }
        },
        handleBlur: function () {
            this.$emit("update-map");
        }
    }

});
